import { getPortalCatalog, getPortalMe, placePortalOrder, quotePortalOrder } from '@api/b2bPortal';
import PageHeader from '@components/common/PageHeader';
import { useQuery } from '@tanstack/react-query';
import React from 'react';
import { useNavigate } from 'react-router';

import OrderForm from '../OrderForm';
import styles from '../b2b.module.css';

const PortalNewOrder: React.FC = () => {
    const navigate = useNavigate();
    const { data: me } = useQuery({ queryKey: ['portal-me'], queryFn: getPortalMe });
    const { data: catalog } = useQuery({ queryKey: ['portal-catalog'], queryFn: getPortalCatalog });

    return (
        <div className="flex h-full w-full flex-col gap-6 page-shell">
            <PageHeader icon="🛒" title="New order" subtitle="Prices are before GST. The brand reviews your order and sends a proforma invoice." />
            {me && !me.orderingOpen ? <span className={styles.error}>Ordering is closed for now. Contact the brand.</span> : null}
            {me && catalog ? (
                <OrderForm
                    catalog={catalog}
                    shipTos={me.shipTos}
                    quote={quotePortalOrder}
                    onPlace={async (input) => {
                        const order = await placePortalOrder(input);
                        void navigate(`/portal/orders/${encodeURIComponent(order.purchaseOrderId)}`);
                    }}
                />
            ) : (
                <span className={styles.muted}>Loading your catalogue…</span>
            )}
        </div>
    );
};

export default PortalNewOrder;
